<div class=" card mt-3">

    <div class="row">
        <div class="col-6">   <h5 i18n>
            Payment Methods
        </h5></div>
        <div class="col-6 text-right"><span style="    color: red;
    margin-top: 10px;
    font-size: 12px;" *ngIf="selectedMethod.code == '-1' && this.customer !=null" i18n>Click to select a payment method.</span></div>
    </div>


    <div class="row">
        <div class="col-md-6 text-left"></div>

    </div>
    <div class="addresses_list">

        <div *ngFor="let pmethod of this.paymentMethods" (click)="setMethodSelected(pmethod)" class="address_line">
            <div class="cont" >
                <div class="row ">
                    <div class="col-8">
                        <div class="name">{{pmethod.title}}</div>
                        <!--                        <div class="mt-3" *ngIf="showAll == false && selectedMethod.method_code == smethod.method_code"><a-->
                        <!--                                href="#"-->
                        <!--                                (click)="showAllShippingMethods($event)">Click-->
                        <!--                            to change shipping method.</a></div>-->
                    </div>
                    <div class="col-4 text-right actions">
                        <i *ngIf="selectedMethod.code == pmethod.code" class="la la-check-circle" style="    color: green;
    font-size: 30px;"></i>
                        <i *ngIf="selectedMethod.code != pmethod.code" class="la la-circle" style="    color: #222;
    font-size: 30px;
  "></i>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
